import { Component, ViewChild, EventEmitter, Output, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { Dialog } from 'primeng/dialog/dialog';
import {
    CodigoConfeccionImportacionItemResultsViewModel,
    CodigoConfeccionImportacionViewModel,
    FilterSearchingCodigoConfeccionImportacionViewModel,
} from '../../../../../_mantenimiento/registros/registrosanitario/registrosanitario.types';
import { EnumSiNoTodos } from '../../../../../core/_infrastructure/types/common';
import { RegistroSanitarioService } from '../../../../../_mantenimiento/registros/registrosanitario/registrosanitario.service';
import { catchError, of, tap } from 'rxjs';

@Component({
    selector: 'app-buscador-codigoconfeccion-list',
    templateUrl: './buscador-codigoconfeccion-list.component.html',
})
export class BuscadorCodigoConfeccionListComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<CodigoConfeccionImportacionViewModel>();
    @Output() selectedImpLugarDestino = new EventEmitter<CodigoConfeccionImportacionViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    resultsCodigoConfeccion: CodigoConfeccionImportacionItemResultsViewModel | null;
    payload?: FilterSearchingCodigoConfeccionImportacionViewModel;
    cols: any[];
    first: number = 0; // Página inicial

    selectedCodigoConfeccion: CodigoConfeccionImportacionViewModel | null;

    display = false;
    visibilitySpinner = false;

    isCollapsed = false;
    isImpLugarDestino = false;

    constructor(
        private fb: UntypedFormBuilder,
        private notificacionService: NotificationService,
        private registroSanitarioService: RegistroSanitarioService,
        private cdr: ChangeDetectorRef,
    ) {
        super();

        this.resultsCodigoConfeccion = new CodigoConfeccionImportacionItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'RegistroSanitario', header: 'Registro sanitario' },
            { field: 'RazonSocial', header: 'Razón social' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'Municipio', header: 'Municipio' },
            { field: 'Provincia', header: 'Provincia' },
            { field: 'Ca', header: 'Comunidad autónoma' },
        ];

        this.form = this.fb.group({
            RegistroSanitario: '',
            RazonSocial: '',
        });

        this.isCollapsed = false;
    }

    onSearchButtonClicked(): void {
        // Evitar múltiples clics si ya estamos cargando datos
        if (this.loading) {
            return;
        }

        // Establecer el estado de carga antes de comenzar la búsqueda
        this.loading = true;
        this.first = 0; // Asegurarse de que estamos comenzando desde la primera página

        // Limpiar los resultados anteriores
        this.resultsCodigoConfeccion = new CodigoConfeccionImportacionItemResultsViewModel();

        // Actualizar el payload antes de hacer la búsqueda
        const payloadVM: FilterSearchingCodigoConfeccionImportacionViewModel = {
            RegistroSanitario: this.form.value.RegistroSanitario,
            RazonSocial: this.form.value.RazonSocial,
            PageNumber: 0,
            Asc: 0,
            OrderBy: '',
            Activo: EnumSiNoTodos.SI,
        };

        // Asignamos el payload actualizado
        this.payload = payloadVM;

        // Llamar a la función de búsqueda con el nuevo payload
        this.onSearch(this.payload);
    }

    onSearch(payload: FilterSearchingCodigoConfeccionImportacionViewModel): void {
        this.selectedCodigoConfeccion = null;

        this.registroSanitarioService
            .getRegistrosSanitarios(payload)
            .pipe(
                tap((res: CodigoConfeccionImportacionItemResultsViewModel) => {
                    this.resultsCodigoConfeccion = res;

                    // Para mostrar el grid
                    this.searchingButton = true;

                    // Cambiar el estado de carga después de que los resultados son recibidos
                    this.loading = false;

                    // Forzar la detección de cambios para asegurarnos de que Angular actualice el estado visual
                    this.cdr.detectChanges();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSearchLazy(event: any): void {
        if (this.loading) {
            return; // Evitar que la búsqueda lazy se ejecute mientras estamos cargando
        }

        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        this.loading = true;

        const payload = {
            ...this.payload,
            PageNumber: event.first / event.rows,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        } as FilterSearchingCodigoConfeccionImportacionViewModel;
        this.onSearch(payload);
    }

    onCleanButton(): void {
        this.form.setValue({
            RegistroSanitario: '',
            RazonSocial: '',
        });

        this.searchingButton = false;
        this.isCollapsed = false;
        this.selectedCodigoConfeccion = null;

        this.resultsCodigoConfeccion = new CodigoConfeccionImportacionItemResultsViewModel();
    }

    resetPagination(): void {
        this.first = 0; // Resetear la paginación
        this.loading = true; // Opcional: activar el estado de carga si es necesario
        this.onSearch(this.payload!); // Llamar a la función de búsqueda para cargar nuevos datos
    }

    showDialog(esLugarDestino: boolean): void {
        this.onCleanButton();

        this.display = true;
        this.selectedCodigoConfeccion = null;
        this.isImpLugarDestino = esLugarDestino;
    }

    Emit(codigoConfeccionImportacion: CodigoConfeccionImportacionViewModel): void {
        if (codigoConfeccionImportacion.RegistroSanitario) {
            this.display = false;

            if (this.isImpLugarDestino) {
                this.selectedImpLugarDestino.emit(codigoConfeccionImportacion);
            } else {
                this.selected.emit(codigoConfeccionImportacion);
            }
        } else {
            this.notificacionService.addErrorMessage('Debe seleccionar un Registro sanitario');
        }
    }

    onRowDblClick(event: any, codigoConfeccionImportacion: CodigoConfeccionImportacionViewModel): void {
        this.Emit(codigoConfeccionImportacion);
    }

    onSelect(selection: CodigoConfeccionImportacionViewModel): void {
        // this.selectedCodigoConfeccion = selection;
        // emarti69: Se comenta porque con la etiqueta [(selection)] del html ya sirve para que se haga bien la selección.
    }

    acceptDialog(): void {
        this.display = false;

        this.Emit(this.selectedCodigoConfeccion!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    noAccepted(): boolean {
        return !this.form.valid || !this.selectedCodigoConfeccion;
    }
}
